import React from 'react';

import { Chip } from '@material-ui/core';
import { makeStyles, darken } from '@material-ui/core/styles';

import { Icon, Translate } from '@hydra/common/components';

import { CRITERIUM_STATUS } from '@hydra/utils/criterium';
import { sendEvent } from '@hydra/utils/gtm';

const useStyles = makeStyles(theme => ({
  successIcon: {
    color: theme.palette.success.dark
  },
  warningIcon: {
    color: theme.palette.warning.darker
  },
  errorIcon: {
    color: theme.palette.error.darker
  },
  greyIcon: {
    color: theme.palette.text.primary
  },
  successOutlined: {
    borderColor: theme.palette.success.dark,
    color: theme.palette.success.dark,
    backgroundColor: theme.palette.success.smoke,
    fontWeight: theme.typography.fontWeightSemibold,
    '&:hover': {
      backgroundColor: `${theme.palette.success.light} !important`
    },
    '&:focus': {
      backgroundColor: `${theme.palette.success.smoke} !important`
    }
  },
  warningOutlined: {
    borderColor: theme.palette.warning.dark,
    color: theme.palette.warning.dark,
    backgroundColor: theme.palette.warning.smoke,
    fontWeight: theme.typography.fontWeightSemibold,
    '&:hover': {
      backgroundColor: `${theme.palette.warning.light} !important`
    },
    '&:focus': {
      backgroundColor: `${theme.palette.warning.smoke} !important`
    }
  },
  errorOutlined: {
    borderColor: theme.palette.error.dark,
    color: theme.palette.error.dark,
    backgroundColor: theme.palette.error.smoke,
    fontWeight: theme.typography.fontWeightSemibold,
    '&:hover': {
      backgroundColor: `${theme.palette.error.light} !important`
    },
    '&:focus': {
      backgroundColor: `${theme.palette.error.smoke} !important`
    }
  },
  greyOutlined: {
    borderColor: theme.palette.text.primary,
    color: darken(theme.palette.text.primary, 0.3),
    backgroundColor: theme.palette.background.secondary,
    fontWeight: theme.typography.fontWeightSemibold,
    '&:hover': {
      backgroundColor: `${theme.palette.background.secondary} !important`
    },
    '&:focus': {
      backgroundColor: `${theme.palette.background.secondary} !important`
    }
  },
  inactive: {
    borderColor: theme.palette.grey[500],
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.default,
    fontWeight: theme.typography.fontWeightSemibold,
    '&:hover': {
      backgroundColor: `${theme.palette.background.secondary} !important`
    },
    '&:focus': {
      backgroundColor: `${theme.palette.background.default} !important`
    }
  }
}));

export const FilterChip = ({ value, active, handleFilter }) => {
  const { status, text, color, type, event } = CRITERIUM_STATUS[value];
  const classes = useStyles();
  const handleClick = (e) => {
    sendEvent(`review-filter-${event}-toggle`, { status: !active });
    handleFilter(status, e);
  };

  return (
    <Chip
      variant='outlined'
      classes={{
        outlined: active ? classes[`${color}Outlined`] : classes.inactive
      }}
      onClick={handleClick}
      label={<Translate content={text} />}
      icon={active
        ? <Icon type='check' size='md' className={classes[`${color}Icon`]} />
        : <Icon type={type} size='md' />}
    />
  );
};

export default React.memo(FilterChip);
